export default "__VITE_ASSET__484af841__"